import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link, useHistory } from 'react-router-dom';
import { Table, Modal, Button } from 'react-bootstrap';
import { FaPlus, FaCheck, FaThumbsUp, FaTimes, FaTrash, FaEdit, FaSortAmountUp, FaSortAmountDown, FaUniversalAccess, FaTools, FaChalkboardTeacher, FaArrowLeft, FaArrowRight, FaChevronUp, FaChevronDown, FaPlay } from 'react-icons/fa';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';
import { getAuthToken } from '../../authToken';


const Etude_de_cas = ({ titre }) => {
    useAuth();
    const [etude, setEtude] = useState([]);
    const [selectedEtude, setSelectedEtude] = useState(null);
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [etudeDescriptionOverflows, setEtudeDescriptionOverflows] = useState({});
    const [isLoading, setIsLoading] = useState(false); // Pour gérer le loader
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [showInfo, setShowInfo] = useState(false);


    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalItems = etude.length;  // Si 'etude' contient tous les etudes

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Etudes de cas"; // Définit le titre de la page
        }
    }, [user_id]);

    // Fetching etudes data from API
    const fetchEtude = async () => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(process.env.REACT_APP_HOTE + `/liste-etude/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            // const response = await fetch(process.env.REACT_APP_HOTE + '/liste-etude/');
            if (response.ok) {
                const data = await response.json();

                // Filtrer uniquement les études avec le statut "Publié"
                const etudesPubliees = data.filter(etude => etude.statut === "Publié");

                setEtude(etudesPubliees);
            } else {
                console.error('Erreur lors de la récupération des études de cas');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchEtude();
    }, []);


    // Handle alerts
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
            fetchEtude()
        }, 3000);
    };


    const handleRowClick = (etude) => {
        setSelectedEtude(etude);
    };

    const handleDemarrerEtude = async (etude) => {
        const etude_id = etude.id; // Assurez-vous que 'id' correspond à l'identifiant correct
        setIsButtonLoading(true)
        try {
            // Effectuer la requête pour démarrer l'étude
            const token = localStorage.getItem('access_token');

            const response = await fetch(process.env.REACT_APP_HOTE + `/demarrer-etude/${user_id}/${etude_id}/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            // const response = await fetch(
            //     `${process.env.REACT_APP_HOTE}/demarrer-etude/${user_id}/${etude_id}/`
            // );

            if (response.ok) {
                const data = await response.json();
                // Rediriger vers la page après succès
                const etude_id = data.etude.id
                navigate('/Etude-demarrer', { state: { etude_id } });
            } else {
                const data = await response.json();
                console.error('Erreur lors de la récupération des études', data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsButtonLoading(false)
        }
    };

    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    // Filter etudes by search term
    const filteredEtude = etude.filter(e =>
        e.tag.toLowerCase().includes(searchTerm.toLowerCase()) ||
        e.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        e.statut.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Sort etudes
    const sortedEtude = [...filteredEtude].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Pagination logic
    const indexOfLastEtude = currentPage * itemsPerPage;
    const indexOfFirstEtude = indexOfLastEtude - itemsPerPage;
    const currentEtude = sortedEtude.slice(indexOfFirstEtude, indexOfLastEtude);
    const totalPages = Math.ceil(sortedEtude.length / itemsPerPage);

    // Handle items per page change
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleToggleDescription = (id) => {
        setExpandedDescriptions((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const checkEtudeDescriptionOverflow = (etude) => {
        etude.forEach((e) => {
            const element = document.getElementById(`etude-description-${e.id}`);
            if (element) {
                setEtudeDescriptionOverflows((prev) => ({
                    ...prev,
                    [e.id]: element.scrollHeight > element.clientHeight,
                }));
            }
        });
    };

    useEffect(() => {
        checkEtudeDescriptionOverflow(etude);
    }, [etude]);



    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("EtudeDeCas")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <div className='row align-items-end'>
                                <h2 className='d-flex align-items-center'><FaChalkboardTeacher size={25} className='mr-2' />Etude de cas
                                </h2>
                                <span
                                    className="ml-3 toggle-icon"
                                    style={{ cursor: 'pointer', marginBottom: '10px' }}
                                    onClick={() => setShowInfo(!showInfo)}
                                >
                                    {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                </span>
                            </div>
                            <div className={`info-box ${showInfo ? "open" : ""}`}>
                                <small>Ces études de cas sont conçues pour permettre une bonne compréhension des processus de gestion de projets étudiés et leur contexte de mise en oeuvre.<br></br> Répondez aux questions avant d'afficher les réponses suggérées.</small>
                            </div>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Etude-de-cas`}> Etude de cas</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="justify-content-center align-items-center mt-3 wrapper wrapper-content animated fadeInRight">
                        <div className="justify-content-center align-items-center">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des études de cas</h5>
                                <div>
                                    {isButtonLoading ? (
                                        <button className="btn btn-success mr-2" disabled>
                                            <i className="fa fa-spinner fa-spin mr-1"></i>
                                            <span className="d-none d-sm-inline ml-2">
                                                Chargement...
                                            </span>
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => handleDemarrerEtude(selectedEtude)}
                                            className={`btn ms-2 mr-2 mt-1 ${selectedEtude ? 'btn-success' : 'btn-default text-dark'}`}
                                            disabled={!selectedEtude}
                                        >
                                            <FaPlay />
                                            <span className="d-none d-sm-inline ml-1">
                                                Démarrer
                                            </span>
                                        </button>
                                    )}
                                </div>
                            </div>

                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>
                                    {alert.message}
                                </div>
                            )}
                            <div className="row justify-content-center align-items-center">
                                <div className="col-lg-12">
                                    <div className="ibox">

                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control col-md-3"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>

                                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary text-wrap d-none d-md-table-celltext-wrap d-none d-md-table-cell' style={{ minWidth: '125px' }} onClick={() => handleSort('id')}>
                                                                Etude de cas {sortConfig.key === 'ordre'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '200px' }} onClick={() => handleSort('titre')}>
                                                                Titre {sortConfig.key === 'titre'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '120px' }} onClick={() => handleSort('statut')}>
                                                                Statut {sortConfig.key === 'statut'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    {!isLoading ? (
                                                        <tbody>
                                                            {currentEtude.length > 0 ? currentEtude.map((etude, index) => (
                                                                <tr
                                                                    key={etude.id}
                                                                    className={`bg-white ${selectedEtude && selectedEtude.id === etude.id ? 'bg-success text-white' : ''}`}
                                                                    onClick={() => handleRowClick(etude)}
                                                                >
                                                                    <td>
                                                                        Cas N°{index + 1}
                                                                        <div className='lesInfos'>
                                                                            {/* <small>Titre : <small dangerouslySetInnerHTML={{ __html: etude.titre }}></small></small><br/> */}
                                                                            <small>Statut : {etude.statut}</small><br />
                                                                            <small>Tag : {etude.tag}</small><br />
                                                                        </div>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">{etude.titre}</td>
                                                                    <td className="d-none d-md-table-cell">{etude.statut}</td>
                                                                </tr>
                                                            )) : (
                                                                <tr>
                                                                    <td colSpan="4" className="text-center"></td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    ) : (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan="8" className="text-center p-5">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <div className="spiner-example">
                                                                            <div className="sk-spinner sk-spinner-wave">
                                                                                <div className="sk-rect1 mr-1"></div>
                                                                                <div className="sk-rect2 mr-1"></div>
                                                                                <div className="sk-rect3 mr-1"></div>
                                                                                <div className="sk-rect4 mr-1"></div>
                                                                                <div className="sk-rect5"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    )}

                                                </table>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstEtude + 1} à ${Math.min(indexOfLastEtude, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5; // Nombre total de pages à afficher
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        // Ajuster le startPage si la fin dépasse le total des pages
                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        // Ajout des boutons de pages
                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    {/* Bouton pour aller à la dernière page */}
                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Etude_de_cas;
